import gql from 'graphql-tag'

// shouldn't do it this way but :shrug:
import { postListVars } from 'libreon/Discuss/graphqlVars'
import { projectListValues } from 'libreon/Project/graphql'

export const userListVars = `
  id
  handle
  name
  avatar
  house
  verified
  lastSeen
`

export const publicUserListVars = `
  ${userListVars}
  tags {
    id
    type
    public
    meta
    tag {
      id
      label
      meta
    }
  }
  updatedAt
  insertedAt
`

const publicUserData = 'data(types: ["profile", "social"]) { id type value }'

const emailListVars = 'id,address,primary,verified'

const userLoadVars = `
  ${publicUserListVars}
  emails {${emailListVars}}
  phones {id,number,primary,verified}
  settings
  access { roles, actions }
  authStatus
  data { id type value }
  messages(action: SUMMARY) { success, meta }
`

export const NOTIFY_PREFS = gql`
  query notifyPrefs($id: ShortId!) {
    users(id: $id) {
      success
      reason
      result {
        id
        notifyPrefs {
          id
          type
          pref
          allow
          updatedAt
        }
      }
    }
  }
`

export const SET_NOTIFY_PREF = gql`
  mutation upsertNotifyUserPref($pref: InputNotifyUserPref!, $id: UUID!) {
    upsertNotifyUserPref(pref: $pref, id: $id) {
      success
      reason
      result {
        id
        type
        pref
        allow
      }
    }
  }
`

export const LOAD_USER = gql`
  query loadUser($id: ShortId!) {
    users(id: $id) {
      success
      reason
      result {
        ${userLoadVars}
      }
    }
  }
`

// id is defined, but only works with self
export const LOAD_USER_MESSAGES = gql`
  query loadUserDiscuss($id: ShortId!) {
    users(id: $id) {
      success
      reason
      result {
        id
        messages {
          success
          results { ...on DiscussPost {
            ${postListVars}
            type recipient { id handle avatar name }
          }}
        }
      }
    }
  }
`

// journeyActor {
//   id
//   journeyLinks {
//     id
//     journey {
//       id
//       name
//     }
//   }
// }

// vs projectListValues which is a bit more
export const publicUserListProj =
  'projects { id type project { id shortId title format } }'

export const PUBLIC_USER_LIST = gql`
  query publicUsers($filter: UserFilter!) {
    publicUsers(filter: $filter) {
      success reason results {
        ${userListVars}
      }
    }
  }
`

export const PUBLIC_USER = gql`
  query publicUser($id: ShortId!) {
    publicUser(id: $id) {
      success
      reason
      result {
        ${publicUserListVars}
        ${publicUserData}
        ${publicUserListProj}
      }
    }
  }
`

export const LOAD_PUBLIC_USER = gql`
  query loadPublicUser($id: ShortId) {
    publicUser(id: $id) {
      success
      reason
      result {
        ${publicUserListVars}
        ${publicUserData}
        projects {
          id
          type
          project {
            ${projectListValues}
          }
        }
      }
    }
  }
`

// journeys {
//   id
// }

export const UPDATE_USER = gql`
  mutation updateUser(
    $id: ShortId, $action: ChangeActions,
    $user: InputUser, $handle: InputHandle, $email: InputEmail,
    $phone: InputPhone, $data: InputMixedData, $role: InputRole)
  {
    updateUser(
      id: $id, action: $action,
      user: $user, handle: $handle, email: $email,
      phone: $phone, data: $data, role: $role)
    {
      success
      reason
      result {
        ${userLoadVars}
      }
    }
  }
`

export const GEN_APIKEY = gql`
  mutation genApiKey {
    genApiKey {
      access
    }
  }
`

// validation

// export const GET_INVITES = gql`
//   mutation getInvites {
//     getInvites {
//       codes
//     }
//   }
// `

export const REQUEST_PASSWORD_RESET = gql`
  mutation requestPasswordReset($email: String, $id: ShortId) {
    requestPasswordReset(email: $email, id: $id) {
      success
      reason
    }
  }
`

export const CHANGE_PASSWORD = gql`
  mutation changePassword($current: String, $new: String!, $code: String) {
    changePassword(current: $current, new: $new, code: $code) {
      success
      reason
    }
  }
`

export const MY_FACTORS = gql`
  query myFactors($type: String, $id: ShortId!) {
    users(id: $id) {
      success
      reason
      result {
        id
        emails {${emailListVars}}
        factors(type: $type) {
          id
          type
          expiresAt
        }
      }
    }
  }
`

export const GET_ACCESS = gql`
  query getAccess($type: AccessDomain!, $refId: UUID!) {
    getAccess(type: $type, refId: $refId)
  }
`

export const inviteValues = `
  id
  shortId
  expiresAt
  requestorId
  requestType
  targetType
  requestAccess
  resourceType
  resourceId
  projectId
  orgId
  email
  targetId
  note
  target {
    ${publicUserListVars}
    id
    name
    handle
  }
`

export const INVITE = gql`
  mutation invite(
    $action: InviteAction!
    $targetType: InviteTargetType
    $requestType: InviteRequestType
    $requestAccess: InviteAccessType
    $responseType: InviteResponseType
    $responseAccess: InviteAccessType
    $resourceType: InviteResourceType
    $resourceId: UUID
    $projectId: UUID
    $targetId: UUID
    $orgId: UUID
    $note: String
    $email: String
    $shortId: ShortId
  ) {
    invite(
      action: $action
      targetType: $targetType
      requestType: $requestType
      requestAccess: $requestAccess
      responseType: $responseType
      responseAccess: $responseAccess
      resourceType: $resourceType
      resourceId: $resourceId
      targetId: $targetId
      projectId: $projectId
      orgId: $orgId
      note: $note
      email: $email
      shortId: $shortId
    ) {
      success
      reason
      result {
        id
        shortId
        expiresAt
      }
    }
  }
`

export const DELETE_ACCOUNT = gql`
  mutation deleteAccount($code: String) {
    deleteAccount(code: $code) {
      success
      reason
    }
  }
`
